// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","ModalCloseButton":"Modal_ModalCloseButton__37r7E"};